// extracted by mini-css-extract-plugin
export default {"value":"CalculationSection_value__tij0i","wrapper":"CalculationSection_wrapper__KQAMG"};